import { Outlet } from '@tanstack/react-router'
import { UmbrellaNav } from '@/widgets/umbrella-nav/UmbrellaNav'

export function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <UmbrellaNav />
      <main className="px-4 py-3 sm:py-10">
        <Outlet />
      </main>
    </div>
  )
}
